module.exports = __webpack_public_path__ + "static/media/JavaFX.43e4dc70.png";